import getIn from 'transmute/getIn';
export const getIndexedAsyncChannelInstances = getIn(['channelInstances', 'instancesByInboxId']);